// extracted by mini-css-extract-plugin
export var MuiPopperRoot = "br_bz";
export var MuiTooltipPopper = "br_bB";
export var button = "br_bJ";
export var icon = "br_j";
export var iconWrapper = "br_bG";
export var qlTooltipLimited = "br_bC";
export var title = "br_bH";
export var wpBlockList = "br_bD";
export var wrapper = "br_bF";